import Wrapper from "../../../layout/Wrapper";
import ClameReportComponent from "../../../screens/reports/clame";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Clame Report",
	description: "",
};

export default function ClameReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ClameReportComponent />
		</Wrapper>
	);
}